import { Controller } from "@hotwired/stimulus"

// Toggles all field checkboxes in the configurable CSV export form from a single
// master checkbox, and keeps the master in sync as individual boxes change.
export default class extends Controller {
  static targets = ["master", "item"]

  toggle() {
    this.itemTargets.forEach((item) => {
      item.checked = this.masterTarget.checked
    })
  }

  sync() {
    if (!this.hasMasterTarget) return
    this.masterTarget.checked = this.itemTargets.every((item) => item.checked)
  }
}
